<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <!-- Dialog error autorizacao -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="autorizacaoDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">Mensagem do Sistema</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemAutorizacaoDialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="logout">Logout</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-alert :type="this.tipoAlerta" timeout="5000" dismissible v-model="showAlert"
      style="margin-bottom: 35px; border-radius: 10px">
      {{ this.mensagemAlerta }}
    </v-alert>

    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">Mensagem do Sistema</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="uploadResultDialog" persistent max-width="80%" style="border-radius: 10px">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #4a4a4a">Resultado de Processamento CSV</span>
            </v-card-title>
            <v-card-text>
              <merus-data-table :headers="headersCSVWithProperties" :items="resultCSV" sort-by="line_number" dense class="elevation-7"
                locale="pt" style="border-radius: 10px" loading-text="Carregando...">
                <template v-slot:item.line_number="{ item }">
                  <CSVItem :value="item.line_number" :error="item.error_line_number" />
                </template>
                <template v-slot:item.client_integration_code="{ item }">
                  <CSVItem :value="item.client_integration_code" :error="item.error_client_integration_code" />
                </template>
                <template v-slot:item.line_integratino_code="{ item }">
                  <CSVItem :value="item.line_integratino_code" :error="item.error_line_integratino_code" />
                </template>
                <template v-slot:item.route_integratino_code="{ item }">
                  <CSVItem :value="item.route_integratino_code" :error="item.error_route_integratino_code" />
                </template>
                <template v-slot:item.vehicle_integratino_code="{ item }">
                  <CSVItem :value="item.vehicle_integratino_code" :error="item.error_vehicle_integratino_code" />
                </template>
                <template v-slot:item.employee_driver_integration_code="{ item }">
                  <CSVItem :value="item.employee_driver_integration_code" :error="item.error_employee_driver_integration_code" />
                </template>
                <template v-slot:item.employee_collector_integration_code="{ item }">
                  <CSVItem :value="item.employee_collector_integration_code" :error="item.error_employee_collector_integration_code" />
                </template>
                <template v-slot:item.id_shift="{ item }">
                  <CSVItem :value="item.id_shift" :error="item.error_id_shift" />
                </template>
                <template v-slot:item.estimated_departure_date="{ item }">
                  <CSVItem :value="item.estimated_departure_date" :error="item.error_estimated_departure_date" />
                </template>
                <template v-slot:item.estimated_arrival_date="{ item }">
                  <CSVItem :value="item.estimated_arrival_date" :error="item.error_estimated_arrival_date" />
                </template>
                <template v-slot:item.effective_date="{ item }">
                  <CSVItem :value="item.effective_date" :error="item.error_effective_date" />
                </template>
                <template v-slot:item.id_order="{ item }">
                  <CSVItem :value="item.id_order" :error="item.error_id_order" />
                </template>
                <template v-slot:item.previous_tolerance="{ item }">
                  <CSVItem :value="item.previous_tolerance" :error="item.error_previous_tolerance" />
                </template>
                <template v-slot:item.posterior_tolerance="{ item }">
                  <CSVItem :value="item.posterior_tolerance" :error="item.error_posterior_tolerance" />
                </template>
                <template v-slot:item.employee_driver_name="{ item }">
                  <CSVItem :value="item.employee_driver_name" :error="item.error_employee_driver_name" />
                </template>
                <template v-slot:item.employee_driver_registration="{ item }">
                  <CSVItem :value="item.employee_driver_registration" :error="item.error_employee_driver_registration" />
                </template>
                <template v-slot:item.employee_collector_name="{ item }">
                  <CSVItem :value="item.employee_collector_name" :error="item.error_employee_collector_name" />
                </template>
                <template v-slot:item.employee_collector_registration="{ item }">
                  <CSVItem :value="item.employee_collector_registration" :error="item.error_employee_collector_registration" />
                </template>
                <template v-slot:item.direction="{ item }">
                  <CSVItem :value="item.direction" :error="item.error_direction" />
                </template>
              </merus-data-table>
            </v-card-text>
            <v-card-actions>
              <strong :style="{ color: showSaveButton ? '#4a4a4a' : 'red' }">{{ this.mensagemUpload }}</strong>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-show="isProcessFinished" @click="downloadArquivoLog">Baixar Log</v-btn>
              <v-btn color="primary" class="white--text" @click="uploadResultDialog = false">Cancelar</v-btn>
              <v-btn v-if="showSaveButton" color="primary" @click="saveBulk">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="uploadDialog" persistent max-width="500" style="border-radius: 10px">
          <v-card>
            <v-card-title style="color: #4a4a4a"> Upload de Arquivos </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="formValidado">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-file-input show-size accept="text/csv" label="Selecione um arquivo CSV..."
                      :rules="[(v) => !!v || 'Selecione um arquivo']" v-model="arquivoCsv"></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <div class="primary--text">{{ this.mensagemUpload }}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-progress-linear indeterminate height="20px" rounded color="primary" v-show="isFileLoading">
                      <div class="white--text">
                        {{ this.mensagemUpload }}
                      </div>
                    </v-progress-linear>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text" @click="submitFile">Upload</v-btn>
              <v-btn color="primary" class="white--text" @click="closeUploadDialog()">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmaSubstDialog" persistent max-width="500" style="border-radius: 10px">
          <v-card>
            <v-card-title color="red"> Confirmação de Substituição </v-card-title>
            <v-card-text>
              <span style="color: #d60000">Já existem viagens previstas para esse dia. Deseja substituir essas viagens?</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text" @click="closeConfirmaSubstDialog()">Cancelar</v-btn>
              <v-btn color="red" class="white--text" @click="confirmarSubstituicao()">Confirmar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="helpDialog" persistent max-width="60%" style="border-radius: 10px">
          <v-card>
            <v-card-title style="color: #4a4a4a">
              <h2>Viagens Previstas - Formato do registro no arquivo CSV</h2>
            </v-card-title>
            <v-card-text style="color: #4a4a4a">
              <h3>
                Os registros no arquivo CSV para carga de viagens previstas em lote devem seguir o
                padrão abaixo
              </h3>
              <br />
              <h4>
                Todos os registros devem ter 18 campos separados por
                <b>;</b> (ponto-e-vírgula)
              </h4>
              <h4>
                Os campos devem estar na ordem abaixo e devem ter as seguintes informações
                :
              </h4>
              <br />
              <h4>
                Campo 1 - Cod. Cliente : código de integração do cliente
              </h4>
              <h4>
                Campo 2 - Cod. Linha : código de integração da linha
              </h4>
              <h4>
                Campo 3 - Cod. Rota : código de integração da rota
              </h4>
              <h4>
                Campo 4 - Cod. Veículo : código de integração do veículo
              </h4>
              <h4>
                Campo 5 - Cod. Motorista : código de integração do motorista
              </h4>
              <h4>
                Campo 6 - Cod. Cobrador : código de integração do cobrador
              </h4>
              <h4>
                Campo 7 - Id Turno : identificador do turno
              </h4>
              <h4>
                Campo 8 - Saída Prevista : data e horário de saída prevista (formato: YYYY-MM-DD HH:MM:SS)
              </h4>
              <h4>
                Campo 9 - Chegada Prevista : data e horário de chegada prevista (formato: YYYY-MM-DD HH:MM:SS)
              </h4>
              <h4>
                Campo 10 - Data Referência : data de referência da viagem (formato: YYYY-MM-DD)
              </h4>
              <h4>
                Campo 11 - Escalonamento : número do escalonamento (ex: 1, 2, 3)
              </h4>
              <h4>
                Campo 12 - Tolerância Adiantamento : tolerância de adiantamento em minutos
              </h4>
              <h4>
                Campo 13 - Tolerância Atraso : tolerância de atraso em minutos
              </h4>
              <h4>
                Campo 14 - Nome Motorista : nome do motorista
              </h4>
              <h4>
                Campo 15 - Matrícula Motorista : matrícula do motorista
              </h4>
              <h4>
                Campo 16 - Nome Cobrador : nome do cobrador
              </h4>
              <h4>
                Campo 17 - Matrícula Cobrador : matrícula do cobrador
              </h4>
              <h4>
                Campo 18 - Sentido : sentido da viagem
              </h4>
              <br />
              <h4>Exemplo :</h4>
              <h4>1;CLI001;LIN001;ROT001;VEI001;MOT001;COB001;1;2024-01-15 08:30:00;2024-01-15 09:15:00;2024-01-15;1;5;10;João Silva;12345;Maria Santos;67890;1</h4>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text" @click="closeHelpDialog()">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-container class="toolbar__container">
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <MultiplaEscolha
            ref="linhasSelect"
            lazy
            get-url="getLinhaslazy"
            :selected-items.sync="idLinhaSelected"
            text="nome_linha"
            value="id_linha"
            label="Linha"
            :max-items="2"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-datetime-picker
            label="De"
            v-model="dti"
            :time-picker-props="timeProps"
            :text-field-props="textFieldProps"
            time-format="HH:mm:ss"
            date-format="dd/MM/yyyy"
            clear-text="Fechar"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock</v-icon>
            </template>
          </v-datetime-picker>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-datetime-picker
            label="Até"
            v-model="dtf"
            :time-picker-props="timeProps"
            :text-field-props="textFieldProps"
            time-format="HH:mm:ss"
            date-format="dd/MM/yyyy"
            clear-text="Fechar"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock</v-icon>
            </template>
          </v-datetime-picker>
        </v-col>
        <v-col cols="12" sm="4" md="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                fab
                color="primary darken-1"
                class="white--text"
                v-bind="attrs"
                v-on="on"
                @click="populaViagensPrevistas"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span>Pesquisar</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <merus-data-table 
    :headers="headersWithProperties" 
    :items="viagensPrevistas" 
    :loading="loadingViagensPrevistas" 
    loading-text="Carregando..." 
    :default-multi-sort="defaultMultiSort"
    >
      <template v-slot:toolbar>
        <CadastroToolbar
          title="Cadastro de Viagens Previstas"
          :token="token"
          :items="viagensPrevistas"
          csv-title="viagens_previstas"
          pdf-title="Viagens Previstas"
          :pdf-headers="headersWithProperties"
          pdf-filename="viagens_previstas"
          hide-search
        >
          <template v-slot:add>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark small class="mb-2 mr-2" fab @click="showHelpDialog" v-on="on">
                <v-icon>mdi-help</v-icon>
              </v-btn>
            </template>
            <span>Help</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark small class="mb-2 mr-2" fab @click="showUploadDialog" v-on="on">
                <v-icon>mdi-file-download</v-icon>
              </v-btn>
            </template>
            <span>Upload de Arquivos</span>
          </v-tooltip>

          <v-dialog v-model="dialog" fullscreen max-width="100%">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-toolbar dark color="primary" ref="myToolbar">
                <v-btn icon dark @click="close">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn dark text @click="save">Salvar</v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-form ref="form" v-model="formValidado">
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.ClientIntegrationCode" label="Código do Cliente *"
                          :rules="[(v) => !!v || 'Código do Cliente é obrigatório']"
                          :disabled="editedIndex !== -1"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.LineIntegrationCode" label="Código da Linha *"
                          :rules="[(v) => !!v || 'Código da Linha é obrigatório']"
                          :disabled="editedIndex !== -1"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.RouteIntegrationCode" label="Código da Rota *"
                          :rules="[(v) => !!v || 'Código da Rota é obrigatório']"
                          :disabled="editedIndex !== -1"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.VehicleIntegrationCode" label="Código do Veículo"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.EmployeeDriverIntegrationCode" label="Código do Motorista"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.EmployeeCollectorIntegrationCode" label="Código do Cobrador"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete v-model="editedItem.IdShift" :items="turnosFiltrados"
                          item-text="descricao_turno" item-value="id_turno" clearable
                          label="Turno *"
                          :rules="[(v) => !!v || 'Turno é obrigatório']"
                          :disabled="editedIndex !== -1"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Order" label="Escalonamento (Order) *"
                          :rules="[(v) => !!v || 'Escalonamento é obrigatório']" type="number"
                          :disabled="editedIndex !== -1"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-datetime-picker
                          label="Data/Hora Saída Prevista *"
                          v-model="estimatedDepartureDate"
                          :time-picker-props="timeProps"
                          :text-field-props="textFieldPropsDisabled"
                          time-format="HH:mm:ss"
                          date-format="dd/MM/yyyy"
                          clear-text="Fechar"
                        >
                          <template slot="dateIcon">
                            <v-icon>mdi-calendar</v-icon>
                          </template>
                          <template slot="timeIcon">
                            <v-icon>mdi-clock</v-icon>
                          </template>
                        </v-datetime-picker>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-datetime-picker
                          label="Data/Hora Chegada Prevista *"
                          v-model="estimatedArrivalDate"
                          :time-picker-props="timeProps"
                          :text-field-props="textFieldProps"
                          time-format="HH:mm:ss"
                          date-format="dd/MM/yyyy"
                          clear-text="Fechar"
                        >
                          <template slot="dateIcon">
                            <v-icon>mdi-calendar</v-icon>
                          </template>
                          <template slot="timeIcon">
                            <v-icon>mdi-clock</v-icon>
                          </template>
                        </v-datetime-picker>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-datetime-picker
                          label="Data de Referência (Effective Date) *"
                          v-model="effectiveDate"
                          :time-picker-props="timeProps"
                          :text-field-props="textFieldProps"
                          time-format="HH:mm:ss"
                          date-format="dd/MM/yyyy"
                          clear-text="Fechar"
                        >
                          <template slot="dateIcon">
                            <v-icon>mdi-calendar</v-icon>
                          </template>
                          <template slot="timeIcon">
                            <v-icon>mdi-clock</v-icon>
                          </template>
                        </v-datetime-picker>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="editedItem.PreviousTolerance" label="Tolerância Adiantamento (minutos) *" 
                          type="number" :rules="[(v) => !!v || 'Tolerância Adiantamento é obrigatório']"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="editedItem.PosteriorTolerance" label="Tolerância Atraso (minutos) * "
                          type="number" :rules="[(v) => !!v || 'Tolerância Atraso é obrigatório']"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="editedItem.EmployeeDriverName" label="Nome do Motorista"
                          :disabled="editedIndex !== -1"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="editedItem.EmployeeDriverRegistration" label="Matrícula do Motorista"
                          :disabled="editedIndex !== -1"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.EmployeeCollectorName" label="Nome do Cobrador"
                          :disabled="editedIndex !== -1"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.EmployeeCollectorRegistration" label="Matrícula do Cobrador"
                          :disabled="editedIndex !== -1"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          </template>
        </CadastroToolbar>
      </template>
      <!-- <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!item.can_edit">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!item.can_delete">mdi-delete</v-icon>
      </template> -->
    </merus-data-table>
  </v-container>
</template>

<script>
import axios from "axios";
import apiController from "@/utils/apiController";
import { ApiBaseUrl } from "@/constants";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import CSVItem from "./CSVItem.vue";
import DateUtils from "@/utils/dateutils.js";
import MultiplaEscolha from "./Selects/MultiplaEscolha.vue";

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    CSVItem,
    MultiplaEscolha
  },
  data: () => ({
    user: null,
    token: null,
    mensagemAutorizacaoDialog: "",
    autorizacaoDialog: false,
    showConfirmButton: true,
    messageConfirmButton: "Sim",
    messageDismissButton: "Não",
    formValidado: true,
    showAlert: false,
    mensagemAlerta: "",
    tipoAlerta: "success",
    dialog: false,
    uploadDialog: false,
    helpDialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    arquivoCsv: null,
    mensagemUpload: "",
    fimProcesso: false,
    fileLoading: false,
    arquivoLog: null,
    loadingViagensPrevistas: false,
    uploadResultDialog: false,
    showSaveButton: false,
    resultCSV: [],
    headers: [
      { text: "IdViagem", value: "id_viagem_prevista", align: " d-none" },
      { text: "Linha", value: "cod_linha", sortable: true },
      { text: "Veículo", value: "VehicleIntegrationCode", sortable: true },
      { text: "Motorista", value: "motorista", sortable: true },
      { text: "Cobrador", value: "cobrador", sortable: true },
      { text: "Sentido", value: "descricao_sentido", sortable: true },
      { text: "Turno", value: "descricao_turno", sortable: true },
      { text: "Escalonamento", value: "Order", sortable: true },
      { text: "Horário Saída", value: "EstimatedDepartureDate", align: " d-none" ,sortable: true },
      { text: "Horário Saída", value: "horario_saida_extenso", sortable: false },
      { text: "Horário Chegada", value: "EstimatedArrivalDate", align: " d-none" ,sortable: true },
      { text: "Horário Chegada", value: "horario_chegada_extenso", sortable: true },
      { text: "Data de Referência", value: "EffectiveDate", align: " d-none" ,sortable: true },
      { text: "Data de Referência", value: "data_referencia_extenso", sortable: true },
      { text: "Data Inclusão", value: "data_inclusao", align: " d-none" ,sortable: true },
      { text: "Data Inclusão", value: "data_inclusao_extenso", sortable: true },
      { text: "Origem", value: "Origem", sortable: true },
      // { text: "Ações", value: "actions", sortable: false },
    ],
    headersCSV: [
      { text: "N° Linha", value: "line_number" },
      { text: "Cod. Cliente", value: "client_integration_code" },
      { text: "Cod. Linha", value: "line_integratino_code" },
      { text: "Cod. Rota", value: "route_integratino_code" },
      { text: "Cod. Veículo", value: "vehicle_integratino_code" },
      { text: "Cod. Motorista", value: "employee_driver_integration_code" },
      { text: "Cod. Cobrador", value: "employee_collector_integration_code" },
      { text: "Id Turno", value: "id_shift" },
      { text: "Saída Prevista", value: "estimated_departure_date" },
      { text: "Chegada Prevista", value: "estimated_arrival_date" },
      { text: "Data Referência", value: "effective_date" },
      { text: "Escalonamento", value: "id_order" },
      { text: "Tolerância Adiantamento", value: "previous_tolerance" },
      { text: "Tolerância Atraso", value: "posterior_tolerance" },
      { text: "Nome Motorista", value: "employee_driver_name" },
      { text: "Matrícula Motorista", value: "employee_driver_registration" },
      { text: "Nome Cobrador", value: "employee_collector_name" },
      { text: "Matrícula Cobrador", value: "employee_collector_registration" },
      { text: "Sentido", value: "direction" }
    ],
    defaultMultiSort: [
      { value: "cod_linha", options: { text: "Crescente", value: 1 } },
      { value: "estimated_departure_date", options: { text: "Crescente", value: 1 } },
    ],
    viagensPrevistas: [],
    sentidos: [],
    turnos: [],
    editedIndex: -1,
    editedItem: {
      ClientIntegrationCode: null,
      LineIntegrationCode: null,
      RouteIntegrationCode: null,
      VehicleIntegrationCode: null,
      EmployeeDriverIntegrationCode: null,
      EmployeeCollectorIntegrationCode: null,
      IdShift: null,
      EstimatedDepartureDate: null,
      EstimatedArrivalDate: null,
      EffectiveDate: null,
      Order: null,
      PreviousTolerance: null,
      PosteriorTolerance: null,
      EmployeeDriverName: null,
      EmployeeDriverRegistration: null,
      EmployeeCollectorName: null,
      EmployeeCollectorRegistration: null,
    },
    deletedItem: {
      ClientIntegrationCode: null,
      LineIntegrationCode: null,
      RouteIntegrationCode: null,
      VehicleIntegrationCode: null,
      EmployeeDriverIntegrationCode: null,
      EmployeeCollectorIntegrationCode: null,
      IdShift: null,
      EstimatedDepartureDate: null,
      EstimatedArrivalDate: null,
      EffectiveDate: null,
      Order: null,
      PreviousTolerance: null,
      PosteriorTolerance: null,
      EmployeeDriverName: null,
      EmployeeDriverRegistration: null,
      EmployeeCollectorName: null,
      EmployeeCollectorRegistration: null,
    },
    defaultItem: {
      ClientIntegrationCode: null,
      LineIntegrationCode: null,
      RouteIntegrationCode: null,
      VehicleIntegrationCode: null,
      EmployeeDriverIntegrationCode: null,
      EmployeeCollectorIntegrationCode: null,
      IdShift: null,
      EstimatedDepartureDate: null,
      EstimatedArrivalDate: null,
      EffectiveDate: null,
      Order: null,
      PreviousTolerance: null,
      PosteriorTolerance: null,
      EmployeeDriverName: null,
      EmployeeDriverRegistration: null,
      EmployeeCollectorName: null,
      EmployeeCollectorRegistration: null,
    },
    estimatedDepartureDate: null,
    estimatedArrivalDate: null,
    effectiveDate: null,
    dti: null,
    dtf: null,
    config: null,
    textFieldProps: {
      prependInnerIcon: "mdi-calendar",
      rules: [(v) => !!v || "Selecione uma data !"],
    },
    timeProps: {
      useSeconds: false,
    },
    /** Linha usada para restringir os turnos (traz unidades); resolvida sob demanda. */
    linhaParaTurnos: null,
    /** Cache codigo -> linha, para o codigo de integracao digitado no formulario. */
    linhaPorCodigo: {},
    idLinhaSelected: [],
    confirmaSubstDialog: false,
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Cadastrar Viagem Prevista" : "Editar Viagem Prevista";
    },
    headersWithProperties() {
      return this.headers.map(h => ({ ...h, filtrable: true, sortable: h.sortable !== false }));
    },
    headersCSVWithProperties() {
      return this.headersCSV.map(h => ({ ...h, filtrable: true, sortable: true }));
    },
    isProcessFinished() {
      return this.fimProcesso;
    },
    isFileLoading() {
      return this.fileLoading;
    },
    textFieldPropsDisabled() {
      return {
        ...this.textFieldProps,
        disabled: this.editedIndex !== -1
      };
    },
    turnosFiltrados() {
      const linha = this.linhaParaTurnos;
      const ids = linha && Array.isArray(linha.unidades)
        ? linha.unidades.map((x) => Number(x)).filter((x) => !Number.isNaN(x))
        : [];
      if (!ids.length) {
        return this.turnos;
      }
      return this.turnos.filter(
        (t) => !t.id_unidade || ids.includes(Number(t.id_unidade))
      );
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    idLinhaSelected() {
      this.resolveLinhaParaTurnos();
    },
    'editedItem.LineIntegrationCode'() {
      this.resolveLinhaParaTurnos();
    },
    linhaParaTurnos() {
      if (
        this.editedItem.IdShift != null &&
        !this.turnosFiltrados.some((t) => Number(t.id_turno) === Number(this.editedItem.IdShift))
      ) {
        this.editedItem.IdShift = null;
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
    this.populaSentidos();
    this.populaTurnos();
  },
  mounted() { },
  methods: {
    logout() {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("api");
      var id = window.setTimeout(function () { }, 0);
      while (id--) {
        window.clearTimeout(id);
      }
      this.$router.push({ path: "/" });
    },
    initialize() {
      apiController.request(apiController.endpoints.getallConfig, {
        silent: true,
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
        },
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaViagensPrevistas() {
      this.loadingViagensPrevistas = true;
      apiController.request(apiController.endpoints.transoftGetGridallviagenspordata, {
        data: {
          dti: DateUtils.getDateSQLFormatted(this.dti),
          dtf: DateUtils.getDateSQLFormatted(this.dtf),
          idlinhas: this.idLinhaSelected.length > 0 ? this.idLinhaSelected : null,
        },
        silent: true,
        onSuccess: (response) => {
          this.viagensPrevistas = response.data;
          this.loadingViagensPrevistas = false;
        },
        onError: (e) => {
          this.loadingViagensPrevistas = false;
          console.log("ERRO AXIOS");
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaSentidos() {
      apiController.request(apiController.endpoints.getallSentidos, {
        silent: true,
        onSuccess: (response) => {
          this.sentidos = response.data;
        },
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaTurnos() {
      apiController.request(apiController.endpoints.getallTurnos, {
        silent: true,
        onSuccess: (response) => {
          this.turnos = response.data;
        },
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    /**
     * Define a linha que restringe os turnos: a selecionada no filtro (quando ha
     * exatamente uma) ou, no formulario, a do codigo de integracao digitado.
     * O select e lazy, entao a linha vem do cache dele ou de uma busca por codigo.
     */
    resolveLinhaParaTurnos() {
      if (Array.isArray(this.idLinhaSelected) && this.idLinhaSelected.length === 1) {
        const ref = this.$refs.linhasSelect;
        const cached =
          ref && typeof ref.getCachedSelectedItem === 'function'
            ? ref.getCachedSelectedItem(this.idLinhaSelected[0])
            : null;
        if (cached) {
          this.linhaParaTurnos = cached;
          return;
        }
      }
      const code =
        this.editedItem && this.editedItem.LineIntegrationCode != null
          ? String(this.editedItem.LineIntegrationCode).trim()
          : '';
      if (code === '') {
        this.linhaParaTurnos = null;
        return;
      }
      this.buscaLinhaPorCodigo(code).then((linha) => {
        this.linhaParaTurnos = linha;
      });
    },
    /**
     * Linha cujo cod_linha ou cod_integracao_linha e exatamente o codigo informado.
     * Usa o getalllinhas paginado (o unico que devolve unidades e cod_integracao_linha
     * juntos); os filtros sao LIKE, entao a comparacao exata fica no cliente.
     */
    async buscaLinhaPorCodigo(code) {
      if (this.linhaPorCodigo[code] !== undefined) {
        return this.linhaPorCodigo[code];
      }
      const consultar = async (filtro) => {
        // Query montada fora da chamada: um literal aqui viraria allowlist em
        // apiEndpoints (generate:api-endpoints) e descartaria os filter_*.
        const consulta = Object.assign(
          { page: 1, rowsPerPage: 20, total: 'true', showInactives: 'true' },
          filtro
        );
        try {
          const response = await apiController.request(apiController.endpoints.getallLinhas, {
            data: consulta,
            silent: true,
          });
          return response && response.data && Array.isArray(response.data.items)
            ? response.data.items
            : [];
        } catch (e) {
          return [];
        }
      };
      const porCodLinha = await consultar({ filter_cod_linha: code });
      let linha = porCodLinha.find((l) => String(l.cod_linha) === code) || null;
      if (!linha) {
        const porIntegracao = await consultar({ filter_cod_integracao_linha: code });
        linha =
          porIntegracao.find((l) => String(l.cod_integracao_linha || '') === code) || null;
      }
      this.$set(this.linhaPorCodigo, code, linha);
      return linha;
    },
    showHelpDialog() {
      this.helpDialog = true;
    },
    closeHelpDialog() {
      this.helpDialog = false;
    },
    closeUploadDialog() {
      this.$refs.form.resetValidation();
      this.arquivoCsv = null;
      this.arquivoLog = null;
      this.resultCSV = [];
      this.uploadDialog = false;
    },
    showUploadDialog() {
      this.arquivoCsv = null;
      this.fimProcesso = false;
      this.mensagemUpload = null;
      this.fileLoading = false;
      this.uploadDialog = true;
    },
    horarioSaidaRules() {
      if (!this.editedItem.horario_saida) {
        return "Horário de saída é obrigatório";
      }
      return true;
    },
    horarioChegadaRules() {
      if (!this.editedItem.horario_chegada) {
        return "Horário de chegada é obrigatório";
      }
      if (this.editedItem.horario_saida && this.editedItem.horario_chegada) {
        const saida = new Date(`2000-01-01T${this.editedItem.horario_saida}`);
        const chegada = new Date(`2000-01-01T${this.editedItem.horario_chegada}`);
        if (chegada <= saida) {
          return "Horário de chegada deve ser posterior ao horário de saída";
        }
      }
      return true;
    },
    escalonamentoRules() {
      if (this.editedItem.escalonamento !== null && this.editedItem.escalonamento !== undefined) {
        if (this.editedItem.escalonamento < 0) {
          return "Escalonamento deve ser um número positivo";
        }
      }
      return true;
    },
    submitFile() {
      this.$refs.form.validate();
      if (this.formValidado) {
        let formData = new FormData();

        this.mensagemUpload = "Carregando Arquivo...";
        this.fileLoading = true;
        if (this.arquivoCsv) {
          formData.append("arquivocsv", this.arquivoCsv);
          apiController.request(apiController.endpoints.uploadCsv, {
            data: formData,
            onSuccess: () => {
              this.processaArquivo();
            },
            onError: (e) => {
              this.fileLoading = false;
              if (e.message == "Request failed with status code 401") {
                this.mensagemAutorizacaoDialog =
                  "Acesso não autorizado. Token de acesso inválido ou expirado !";
                this.autorizacaoDialog = true;
              }
            },
          });
        } else {
          console.log("there are no files.");
        }
      }
    },
    processaArquivo() {
      this.mensagemUpload = "Processando arquivo....";
      apiController.request(apiController.endpoints.transoftProcessaCsvviagensprevistas, {
        params: { file: this.arquivoCsv.name },
        onSuccess: (response) => {
          this.mensagemUpload = response.data.error ? "Arquivo processado com erros..." : "Arquivo processado com sucesso!";
          this.fileLoading = false;
          this.fimProcesso = true;
          this.arquivoLog = response.data.arqlog;
          this.resultCSV = response.data.result;
          this.showSaveButton = !response.data.error;
          this.uploadResultDialog = true;
        },
        onError: (e) => {
          this.fileLoading = false;
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    downloadArquivoLog() {
      apiController.request(apiController.endpoints.downloadLog, {
        params: { filename: this.baseName(this.arquivoLog) },
        config: { responseType: "blob" },
        silent: true,
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.baseName(this.arquivoLog));
          document.body.appendChild(link);
          link.click();
        },
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    baseName(str) {
      var base = new String(str).substring(str.lastIndexOf("/") + 1);
      return base;
    },
    editItem(item) {
      this.editedIndex = this.viagensPrevistas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.estimatedDepartureDate = new Date(this.editedItem.EstimatedDepartureDate);
      this.estimatedArrivalDate = new Date(this.editedItem.EstimatedArrivalDate);
      this.effectiveDate = new Date(this.editedItem.EffectiveDate);
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = "Confirma a exclusão da viagem prevista " + item.horario_saida + " - " + item.horario_chegada + " ?";
      this.showConfirmButton = true;
      this.messageDismissButton = "Não";
      this.messageConfirmButton = "Sim";
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteViagemprevista, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
        onError: (e) => {
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.estimatedDepartureDate = null;
        this.estimatedArrivalDate = null;
        this.effectiveDate = null;
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        let dataToSend = Object.assign({}, this.editedItem);
        
        // Converter datas para formato esperado pela API (YYYY-MM-DDTHH:MM:SS)
        if (this.estimatedDepartureDate) {
          dataToSend.EstimatedDepartureDate = DateUtils.getDateSQLFormatted(this.estimatedDepartureDate);
        }
        if (this.estimatedArrivalDate) {
          dataToSend.EstimatedArrivalDate = DateUtils.getDateSQLFormatted(this.estimatedArrivalDate);
        }
        if (this.effectiveDate) {
          dataToSend.EffectiveDate = DateUtils.getDateSQLFormatted(this.effectiveDate);
        }
        
        if (this.editedIndex == -1) {
          dataToSend.Origem = "MERUS MANUAL";
          this.operacao = 0;
          axios
            .post(ApiBaseUrl + "/GlobalBus/Grid/Insert", dataToSend, {
              headers: { "x-access-token": this.token },
            })
            .then(() => {
              this.updateTable(false);
            })
            .catch((e) => {
              console.log("ERRO AXIOS");
              console.log(e.message);
              if (e.message == "Request failed with status code 401") {
                this.mensagemAutorizacaoDialog =
                  "Acesso não autorizado. Token de acesso inválido ou expirado !";
                this.autorizacaoDialog = true;
              } else {
                this.updateTable(true);
              }
            });
        } else {
          this.operacao = 1;
          axios
            .post(ApiBaseUrl + "/GlobalBus/Grid/Update", dataToSend, {
              headers: { "x-access-token": this.token },
            })
            .then(() => {
              this.updateTable(false);
            })
            .catch((e) => {
              console.log("ERRO AXIOS");
              console.log(e.message);
              if (e.message == "Request failed with status code 401") {
                this.mensagemAutorizacaoDialog =
                  "Acesso não autorizado. Token de acesso inválido ou expirado !";
                this.autorizacaoDialog = true;
              } else {
                this.updateTable(true);
              }
            });
        }
      }
    },
    saveBulk() {
      if (this.resultCSV.length > 0) {
        console.log(this.resultCSV);
        let temp = this.resultCSV.map((v) => {
          return [
            v.client_integration_code,
            v.line_integration_code,
            v.route_integration_code,
            v.vehicle_integration_code,
            v.employee_driver_integration_code,
            v.employee_collector_integration_code,
            v.id_shift,
            v.estimated_departure_date,
            v.estimated_arrival_date,
            v.effective_date,
            v.id_order,
            v.previous_tolerance,
            v.posterior_tolerance,
            v.employee_driver_name,
            v.employee_driver_registration,
            v.employee_collector_name,
            v.employee_collector_registration,
            'MERUS MANUAL'
          ];
        });
        apiController.request(apiController.endpoints.transoftInsertGridbulk, {
          data: temp,
          onSuccess: (response) => {
            if (response.data.error && response.data.Message == "Dup entry") {
              if (response.data.canSubst) {
                this.confirmaSubstDialog = true;
              } else {
                this.closeUploadDialog();
                this.uploadResultDialog = false;
                this.mensagemAlerta = "Falha ao adicionar viagens previstas. Já existem viagens previstas para esse dia.";
                this.tipoAlerta = "error";
                this.showAlert = true;
              }
            } else {
              this.closeUploadDialog();
              this.uploadResultDialog = false;
              this.updateTable(response.data.error);
            }
          },
          onError: (e) => {
            this.closeUploadDialog();
            this.uploadResultDialog = false;
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    deleteBulk() {
      if (this.resultCSV.length > 0) {
        let temp = [];
        this.resultCSV.forEach((v) => {
          if (temp.findIndex(t => t.ClientIntegrationCode == v.client_integration_code && t.LineIntegrationCode == v.line_integration_code && t.EffectiveDate == v.effective_date) == -1) {
            temp.push({
              ClientIntegrationCode: v.client_integration_code,
              LineIntegrationCode: v.line_integration_code,
              EffectiveDate: v.effective_date,
            });
          }
        });

        console.log(temp);
        
        Promise.all(temp.map(t => axios.post(ApiBaseUrl + "/GlobalBus/Grid/DeleteAllGrid", t, {
          headers: { "x-access-token": this.token },
        })))
          .then(() => {
            this.saveBulk();
          })
          .catch((e) => {
            this.mensagemAlerta = "Erro ao excluir viagens previstas";
            this.tipoAlerta = "error";
            this.showAlert = true;
            console.log("ERRO AXIOS");
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          });
        }
    },
    updateTable(status) {
      if (status) {
        if (this.operacao == 0) {
          this.mensagemAlerta = "Erro na inclusão da viagem prevista";
        } else {
          if (this.operacao == 1) {
            this.mensagemAlerta = "Erro na alteração do cadastro da viagem prevista";
          } else {
            this.mensagemAlerta = "Erro na exclusão da viagem prevista";
          }
        }
        this.tipoAlerta = "error";
        this.showAlert = true;
      } else {
        if (this.operacao == 0) {
          this.mensagemAlerta = "Viagem prevista incluída com sucesso";
        } else {
          if (this.operacao == 1) {
            this.mensagemAlerta = "Viagem prevista alterada com sucesso";
          } else {
            this.mensagemAlerta = "Viagem prevista excluída com sucesso";
          }
        }
        this.tipoAlerta = "success";
        this.showAlert = true;
      }
      this.close();
      this.initialize();
    },
    confirmarSubstituicao() {
      this.confirmaSubstDialog = false;
      this.deleteBulk();
    },
    closeConfirmaSubstDialog() {
      this.confirmaSubstDialog = false;
    },
  },
};
</script>

